
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UseSalesAccessReturn {
  loading: boolean;
  hasAccess: boolean;
  role: string | null;
}

/**
 * Hook to check if the current user has access to the sales dashboard
 */
export const useSalesAccess = (): UseSalesAccessReturn => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          setHasAccess(false);
          setLoading(false);
          return;
        }
        
        const { data: roleData } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', session.user.id)
          .single();
        
        if (roleData) {
          setRole(roleData.role);
          setHasAccess(roleData.role === 'admin' || roleData.role === 'producer');
        } else {
          setHasAccess(false);
        }
      } catch (error) {
        console.error('Error checking user role:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkUserRole();
  }, []);

  return { loading, hasAccess, role };
};
